import React, { useState, useEffect } from 'react';

const StepTypeClient = ({ formData, onChange }) => {
  const [showGarantInfo, setShowGarantInfo] = useState(false);
  
  // Afficher les instructions spéciales pour les garants
  useEffect(() => {
    setShowGarantInfo(formData.aGarant === 'oui');
  }, [formData.aGarant]);

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h2 className="text-2xl font-bold mb-6 text-orpi-secondary">
        Êtes-vous locataire ou garant ?
      </h2>

      <div className="space-y-6">
        <div className="grid grid-cols-2 gap-4">
          <button
            type="button"
            className={`p-3 border rounded-lg hover:border-orpi-primary ${
              formData.typeClient === 'locataire' ? 'border-orpi-primary bg-orpi-light' : ''
            }`}
            onClick={() => onChange({ target: { name: 'typeClient', value: 'locataire' } })}
          >
            Locataire
          </button>
          <button
            type="button"
            className={`p-3 border rounded-lg hover:border-orpi-primary ${
              formData.typeClient === 'garant' ? 'border-orpi-primary bg-orpi-light' : ''
            }`}
            onClick={() => onChange({ target: { name: 'typeClient', value: 'garant' } })}
          >
            Garant
          </button>
        </div>

        {formData.typeClient === 'locataire' && (
          <div>
            <label className="block text-sm font-medium mb-1 text-orpi-secondary">
              Avez-vous un garant ?
            </label>
            <div className="grid grid-cols-2 gap-4">
              <button
                type="button"
                className={`p-3 border rounded-lg hover:border-orpi-primary ${
                  formData.aGarant === 'oui' ? 'border-orpi-primary bg-orpi-light' : ''
                }`}
                onClick={() => onChange({ target: { name: 'aGarant', value: 'oui' } })}
              >
                Oui
              </button>
              <button
                type="button"
                className={`p-3 border rounded-lg hover:border-orpi-primary ${
                  formData.aGarant === 'non' ? 'border-orpi-primary bg-orpi-light' : ''
                }`}
                onClick={() => onChange({ target: { name: 'aGarant', value: 'non' } })}
              >
                Non
              </button>
            </div>
          </div>
        )}

        {showGarantInfo && (
          <div className="bg-blue-50 border-l-4 border-blue-500 p-4 rounded-r">
            <p className="text-blue-800">
              <strong>Important :</strong> Veuillez également transmettre ce même formulaire à votre garant afin qu'il puisse le compléter. 
              Ses revenus seront ajoutés à votre dossier, ce qui augmentera vos chances d'acceptation.
            </p>
          </div>
        )}

        {formData.typeClient === 'locataire' && formData.aGarant === 'oui' && (
          <div>
            <label className="block text-sm font-medium mb-1 text-orpi-secondary">
              Nom du garant
            </label>
            <input
              type="text"
              name="nomGarant"
              value={formData.nomGarant || ''}
              onChange={onChange}
              className="w-full p-3 border rounded-lg focus:border-orpi-primary focus:ring-orpi-primary"
              placeholder="Nom complet du garant"
              required
            />
          </div>
        )}

        {formData.typeClient === 'garant' && (
          <div>
            <label className="block text-sm font-medium mb-1 text-orpi-secondary">
              Nom du locataire pour lequel vous êtes garant
            </label>
            <input
              type="text"
              name="nomLocataire"
              value={formData.nomLocataire || ''}
              onChange={onChange}
              className="w-full p-3 border rounded-lg focus:border-orpi-primary focus:ring-orpi-primary"
              placeholder="Nom complet du locataire"
              required
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default StepTypeClient;